import React, { useState, useEffect, useRef } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Button from "react-bootstrap/Button";
import { useNavigate, useLocation } from "react-router-dom";
import WantAdLandMustHaves from "./AgentWantAd/WantAdLandMustHaves";
import WantAdBudget from "./AgentWantAd/WantAdBudget";
import WantAdType from "./AgentWantAd/WantAdType";
import WantAdDescription from "./AgentWantAd/WantAdDescription";
import WantAdTiming from "./AgentWantAd/WantAdTiming";
import WantAdLocation from "./AgentWantAd/WantAdLocation";
import WantAdOptimizationScore from "./AgentWantAd/WantAdOptimizationScore";
import WantAdCalendar from "./AgentWantAd/WantAdCalendar";
import WantAdRentPropertyTypes from "./AgentWantAd/WantAdRentPropertyTypes";
import WantAdRentMustHavePrivate from "./AgentWantAd/WantAdRentMustHavePrivate";
import WantAdMustHaves from "./AgentWantAd/WantAdMustHaves";
import WantAdShortRentMstHves from "./AgentWantAd/WantAdShortRentMstHves";
import WantAdRentMustHaves from "./AgentWantAd/WantAdRentMustHaves";
import WantAdPropertyPurchase from "./AgentWantAd/WantAdPropertyPurchase";
import WantAdRentCreditScore from "./AgentWantAd/WantAdRentCreditScore";
import WantAdPurchaseFinance from "./AgentWantAd/WantAdPurchaseFinance";
import {
  LONG_RENT,
  SHORT_RENT,
  BUY,
  AGENT_WANTAD_KEY,
  IS_PRIVATE_ROOM,
  IS_LAND,
  USER_INFO_KEY,
  USER_TYPE_AGENT,
  DATE_FORMAT_MM_DD_YYYY,
} from "@/constants/common";
import {
  saveMemberWantAd,
  saveMemberWantAdstrengthenData,
} from "@/services/v2/wantAdService";
import { pageURLs } from "@/constants";
import BackButton from "./Common/BackButton";
import {
  getLocalStorage,
  setLocalStorage,
  loggedInUser,
  getUserId,
  createPreSignedUrl,
  createPreSignedUrlForVideo,
  clearLocalStorage,
  getUserType,
  removeLocalStorage,
  isValidDate,
} from "@/helpers/v2/common";
import { convertToNumber, textValidations } from "@/helpers/validations";
import NiceToHave from "./Common/NiceToHave/NiceToHave";
import AiNiceToHaveSuggestions from "./AgentWantAd/AiNiceToHaveSuggestions";
import ClientSelection from "./Common/AgentClientSelection/ClientSelection";
import {
  uploadMapImageToS3,
  uploadVideoToS3,
} from "@/helpers/S3/uploadToS3";
import { EXACT_MOVE_DATE_TYPE } from "@/constants/createWantAd";
import { dataURLToBlob, getEditAction } from "@/helpers/createWantAd";
import GitchaNotAvailableModal from "./Common/GitchaNotAvailableModal";
import { checkGitchaAvailable } from "@/services/commonServices";
import RequestStayAvailability from "./Common/RequestStayAvailability";
import { useDispatch } from "react-redux";
import { userLogout } from "@/reducers/login";
import { useSelector } from "react-redux";
import Loader from "./Common/Loader";
import WantListingSyndication from "./AgentWantAd/v2/WantListingSyndication";
import BuyerAgreement from "./AgentWantAd/v2/BuyerAgreement";
import useComplianceCheck from "@/hooks/useComplianceCheck";
import ComplianceWarning from "@/components/Messages/ComplianceWarning";
import "./AgentWantAdForm.scss";
import { PageWrapper } from "@/components/PageWrapper";
import { useCurrentWebsite } from "@/hooks/useCurrentWebsite";
import { useMLSAgentAtGitchaHomeRedirect } from "@/hooks/useMLSAgentAtGitchaRedirect";
import useLoading from "@/hooks/useLoading";
import {
  getTenantSubdomain,
  isSyndicationCheckedByDefault,
} from "@/helpers/tenant";
import _ from "lodash"

const LOADING_KEY = "saveDraftWantAd";

// Hostname-based, not feature-flag-based: a browser can serve a stale tenant config.
const TENANTS_WITH_CONCESSIONS = ["blc"];

const SCROLL_OFFSET = 80;

const AgentWantAdForm = ({ initialData, isEdit }) => {

  const formRef = useRef();

  const targetRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const browserLocation = getLocalStorage("userLocation");

  useMLSAgentAtGitchaHomeRedirect()

  const { startLoading, stopLoading } = useLoading();
  const { isGitchaDefaultWebsite, mls } = useCurrentWebsite();
  const showBuyerConcessions =
    isGitchaDefaultWebsite ||
    TENANTS_WITH_CONCESSIONS.includes(getTenantSubdomain());

  const [wantAdData, setWantAdData] = useState(() => {
    return {
      syndicateToThePublic: isSyndicationCheckedByDefault(),
      syndicateToMlsSubscribers: true,
      adType: BUY,
      ...initialData,
    };
  });

  const isBuyerAgreementChecked = Boolean(wantAdData?.buyersAgreementSigned);

  const isFromNotification =
    location.state && location.state["isFromNotification"];
  const isFromUnPause = location.state && location.state["isFromUnPause"];

  const [disableButton, setDisableButton] = useState(false);
  const [selectedniceToHavesList, setSelectedNiceToHavesList] = useState([]);

  const YEAR_BUILT_MIN = 1900;
  const YEAR_BUILT_MAX = new Date().getFullYear();
  const sessionData = loggedInUser();

  const [gitchaModalShow, setGitchaModal] = useState(false);

  // error tracking
  const [thumbnailImgUrlError, setThumbnailImgUrlError] = useState(false);
  const [videoUrlError, setVideoUrlError] = useState(false);
  const [clientSelectionError, setClientSelectionError] = useState(false);
  const [typeSelectionError, setTypeSelectionError] = useState(false);
  const [locationCityError, setLocationCityError] = useState(false);
  const [locationRadiusError, setLocationRadiusError] = useState(false);
  const [zipCodeError, setZipCodeError] = useState(false);
  const [timeLineError, setTimeLineError] = useState(false);
  const [timelineCalenderError, setTimeCalenderError] = useState(false);
  const [propertyTypeError, setPropertyTypeError] = useState(false);
  const [subPropertyTypeError, setSubPropertyTypeError] = useState(false);
  const [requirementBedroomsError, setRequirementBedroomsError] =
    useState(false);
  const [requirementBathroomsError, setRequirementBathroomsError] =
    useState(false);
  const [budgetError, setBudgetError] = useState(false);
  const [titleTextBoxError, setTitleError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [buyerAgreementError, setBuyerAgreementError] = useState(false);
  const { violations, severity } = useComplianceCheck(wantAdData?.adDesc);
  const [exactMoveDateError, setExactMoveDateError] = useState(false);
  const [requirementTextColor, setRequirementTextColor] = useState(false);
  const [dateTextBoxError, setDateTextBoxError] = useState(false);
  const [showWantadPublished, setShowWantadPublished] = useState(false);
  const [locationError, setLocationError] = useState("");
  const [videoUrl, setVideoUrl] = useState(wantAdData?.videoUrl ?? "");
  const [videoThumbnailUrl, setVideoThumbnailUrl] = useState(
    wantAdData?.thumbnailImgUrl ?? "",
  );
  const isFromConfirmationPage =
    location.state && location.state["isFromConfirmationPage"] ? true : false;

  const userDetailsFromStore = useSelector(
    (state) => state.userProfile.userDetails,
  );
  const [videoUploadProgress, setVideoUploadProgress] = useState(0);
  const [showRequestStayPopuop, setShowRequestStayPopup] = useState(false);
  const handleStayRequestPopupOpen = () => {
    setShowRequestStayPopup(true);
  };

  const handleStayRequestPopupClose = () => {
    setShowRequestStayPopup(false);
  };
  const thumbnailImgUrlRef = useRef(null);
  const ClientRef = useRef(null);
  const adTypeRef = useRef(null);
  const locationRef = useRef(null);
  const timeLineRef = useRef(null);
  const propertyTypeRef = useRef(null);
  const mustHaveRef = useRef(null);
  const BudgetRef = useRef(null);
  const DescriptionRef = useRef(null);
  const BuyerSectionRef = useRef(null);
  const TitleRef = useRef(null);
  const mapRef = useRef(null);

  const userType = getUserType();
  const isAgent = userType === USER_TYPE_AGENT ? true : false;

  const isPremiumUser = userDetailsFromStore[0]?.period !== 1 && userType === 2;

  useEffect(() => {
    const isArchiveValue = getEditAction(isFromUnPause, isFromNotification); // pass the url parameters to the function
    if (isArchiveValue == 0) {
      // unpause/ unarchive action occured
      handleFormValues({ isArchived: 0 });
      if (wantAdData?.adType == SHORT_RENT || wantAdData?.adType == LONG_RENT) {
        handleFormValues({
          startDate: null,
          endDate: null,
          duration: null,
          month: null,
          moveInTimeLine: null,
          moveInDate: null,
        });
      }
    }

    if (isFromUnPause || isFromNotification) {
      if (isFromUnPause == true || isFromNotification == true) {
        handleFormValues({ ExpiryStatus: true }); // for make the notification table entry marked as renewed is the edit is from renew/unpause action
      } else {
        handleFormValues({ ExpiryStatus: false });
      }
    }
  }, [isFromUnPause, isFromNotification]);

  useEffect(() => {
    const userInfo = _.get(getLocalStorage(USER_INFO_KEY), "userInfo", null);
    if (!userInfo) {
      handleStateClear();
    }

    if (isEdit) {
      handleFormValues({ isEdit: true });
    } else if (location.state && location.state["data"]) {
      if (location.state["data"]?.isEdit == false) {
        handleFormValues({ isEdit: false });
      } else {
        handleFormValues({ isEdit: true });
      }
    }
    if (isFromConfirmationPage) {
      handleFormValues({ isEdit: true });
    }
    removeLocalStorage("userAction");
  }, []);

  const handleStateClear = () => {
    dispatch(userLogout());
    clearLocalStorage();
    navigate(pageURLs.home);
  };

  useEffect(() => {
    wantAdData?.nice2Have
      ? setSelectedNiceToHavesList(wantAdData?.nice2Have)
      : setSelectedNiceToHavesList([]);

    setLocalStorage(AGENT_WANTAD_KEY, wantAdData);

    if (wantAdData?.clientId || wantAdData?.isAgentAsSeller) {
      setClientSelectionError(false);
    }

    if (wantAdData?.adType) {
      setTypeSelectionError(false);
    }

    if (
      (wantAdData?.location && wantAdData?.county) ||
      wantAdData?.zipCode?.length > 0
    ) {
      setLocationCityError(false);
      setZipCodeError(false);
    }
    if (wantAdData?.mapRadius) {
      setLocationRadiusError(false);
    }

    if (wantAdData?.adType == BUY && wantAdData?.timeLine) {
      setTimeLineError(false);
      setTimeCalenderError(false);
    }

    if (wantAdData?.adType == LONG_RENT && wantAdData?.moveInTimeLine) {
      setTimeLineError(false);
      setTimeCalenderError(false);
    }
    if (
      wantAdData?.adType == LONG_RENT &&
      wantAdData?.moveInTimeLine == EXACT_MOVE_DATE_TYPE &&
      wantAdData?.startDate
    ) {
      const isDateValid = isValidDate({
        dateString: wantAdData?.startDate,
        format: DATE_FORMAT_MM_DD_YYYY,
      });
      if (!isDateValid) {
      } else {
        setExactMoveDateError(false);
      }
    }
    if (wantAdData?.adType == SHORT_RENT && wantAdData?.dateType) {
      setTimeCalenderError(false);
      setTimeLineError(false);
    }
    if (
      wantAdData?.adType == SHORT_RENT &&
      wantAdData?.dateType &&
      ((wantAdData?.startDate && wantAdData?.endDate) ||
        (wantAdData?.duration && wantAdData?.month))
    ) {
      setDateTextBoxError(false);
    }
    if (wantAdData?.prprtyType != IS_LAND && wantAdData?.prprtyType) {
      if (wantAdData?.prptySubTypes && wantAdData?.prptySubTypes.length > 0) {
        if (wantAdData?.adType == BUY) {
          setPropertyTypeError(false);
        } else {
          setSubPropertyTypeError(false);
        }
      }
    }

    if (wantAdData?.noBedRm) {
      setRequirementBedroomsError(false);
    }

    if (wantAdData?.noBathRm) {
      setRequirementBathroomsError(false);
    }

    if (wantAdData?.adTitle && textValidations(wantAdData?.adTitle)) {
      setTitleError(false);
    }
    if (wantAdData?.noBedRm && wantAdData?.noBathRm) {
      setRequirementTextColor(false);
    }

    if (textValidations(wantAdData?.adDesc)) {
      setDescriptionError(false);
    }

    if (wantAdData?.buyersAgreementSigned) {
      setBuyerAgreementError(false);
    }

    if (wantAdData?.buyersAgreementSigned) {
      setBuyerAgreementError(false);
    }

  }, [wantAdData]);

  /**
   * To handle save to draft
   */
  const handleSaveToDraft = () => {
    if (wantAdData?.focusOut == true && wantAdData?.isPublished != 1) {
      if (wantAdData?.location && wantAdData?.county) {
        setTimeout(() => {
          handleCaptureMapImage("draft", true);
        }, 2000);
        handleFormValues({ focusOut: false });
      } else {
        saveMemberWantAdData(null, true); // true for checking on key up save or not for navigation
        handleFormValues({ focusOut: false });
      }
    }
  };
  /**
   * To clear previous states
   * @param {*} params
   */
  const clearPreviousStates = (params) => {
    if (params) {
      const { type } = params;
      if (type === "clearAll") {
        setWantAdData({
          actvStep: 1,
          cmpldPerctg: 2,
          lat: wantAdData?.lat,
          lng: wantAdData?.lng,
          isPublished: wantAdData?.isPublished,
          buyersAgreementSigned: isBuyerAgreementChecked,
        });
      } else if (type === "clearFlexDates") {
        const array = { ...wantAdData }; // make a separate copy of the state
        ["duration", "month"].forEach((e) => delete array[e]);
        setWantAdData(array);
      } else if (type === "dateRange") {
        const array = { ...wantAdData }; // make a separate copy of the state
        ["startDate", "endDate"].forEach((e) => delete array[e]);
        setWantAdData(array);
      } else if (type === "moveInTypeChangeLTR") {
        const array = { ...wantAdData }; // make a separate copy of the state
        ["startDate"].forEach((e) => delete array[e]);
        setWantAdData(array);
      } else if (type == "clearAllExceptClient") {
        setWantAdData({
          actvStep: 10,
          cmpldPerctg: 2,
          clientData: wantAdData?.clientData,
          clientId: wantAdData?.clientId,
          clientName: wantAdData?.clientName,
          isAgentAsSeller: wantAdData?.isAgentAsSeller,
          wantAdId: wantAdData?.wantAdId,
          s3ImageFolder: wantAdData?.s3ImageFolder,
          userId: wantAdData?.userId,
          lat: wantAdData?.lat,
          lng: wantAdData?.lng,
          isPublished: wantAdData?.isPublished,
          isEdit: wantAdData?.isEdit,
          buyersAgreementSigned: isBuyerAgreementChecked,
        });
        setLocationCityError(false);
        setLocationRadiusError(false);
        setZipCodeError(false);
        setPropertyTypeError(false);
        setRequirementBathroomsError(false);
        setRequirementBedroomsError(false);
        setBudgetError(false);
        setTimeLineError(false);
        setTimeCalenderError(false);
        setDescriptionError(false);
      } else if (type == "clearErrorStateOnPropertySelection") {
        setWantAdData({
          clientData: wantAdData?.clientData,
          clientId: wantAdData?.clientId,
          clientName: wantAdData?.clientName,
          isAgentAsSeller: wantAdData?.isAgentAsSeller,
          wantAdId: wantAdData?.wantAdId,
          s3ImageFolder: wantAdData?.s3ImageFolder,
          userId: wantAdData?.userId,
          lat: wantAdData?.lat,
          lng: wantAdData?.lng,
          city: wantAdData?.city,
          isZipcodeBased: wantAdData?.isZipcodeBased,
          zipCode: wantAdData?.zipCode,
          zipId: wantAdData?.zipId,
          zipIdValues: wantAdData?.zipIdValues,
          state: wantAdData?.state,
          county: wantAdData?.county,
          location: wantAdData?.location,
          mapRadius: wantAdData?.mapRadius,
          mapZoom: wantAdData?.mapZoom,
          drawnPolygon: wantAdData?.drawnPolygon,
          timeLine: wantAdData?.timeLine,
          tlText: wantAdData?.tlText,
          dateType: wantAdData?.dateType,
          duration: wantAdData?.duration,
          month: wantAdData?.month,
          moveInTimeLine: wantAdData?.moveInTimeLine,
          moveInTxt: wantAdData?.moveInTxt,
          startDate: wantAdData?.startDate,
          neighborHood: wantAdData?.neighborHood,
          highSchool: wantAdData?.highSchool,
          prprtyType: wantAdData?.prprtyType,
          prptyTypeTxt: wantAdData?.prptyTypeTxt,
          adType: wantAdData?.adType,
          validationErrors: [],
          isPublished: wantAdData?.isPublished,
          isEdit: wantAdData?.isEdit,
          buyersAgreementSigned: isBuyerAgreementChecked,
        });

        setRequirementBathroomsError(false);
        setRequirementBedroomsError(false);
        setBudgetError(false);
        setTimeLineError(false);
        setTimeCalenderError(false);
        setDescriptionError(false);
        setPropertyTypeError(false);
      }
    }
  };

  const handleFormValues = (stateObject) => {
    Object.keys(stateObject).forEach(function (key) {
      setWantAdData((prevState) => ({
        ...prevState,
        [key]: stateObject[key],
      }));
    });
  };
  /**
   * To calculate percentage of completion
   * @returns
   */
  const calculatePercentageofCompletion = () => {
    let percentage = 0;
    let count = 0;
    if (wantAdData?.clientId) {
      count++;
    }
    if (wantAdData?.adType) {
      count++;
    }
    if (wantAdData?.timeLine) {
      count++;
    }
    if (wantAdData?.location && wantAdData?.location.trim() != "") {
      count++;
    }

    if (
      (wantAdData?.startDate && wantAdData?.endDate) ||
      (wantAdData?.month && wantAdData?.duration)
    ) {
      count++;
    }

    if (wantAdData?.prprtyType) {
      count++;
    }
    if (
      wantAdData?.noBathRm &&
      wantAdData?.noBedRm &&
      wantAdData?.sqFtMax &&
      wantAdData?.sqFtMin
    ) {
      count++;
    }
    if (wantAdData?.maxBdgt) {
      count++;
    }
    if (wantAdData?.acreageMin) {
      count++;
    }
    if (wantAdData?.adTitle) {
      count++;
    }

    percentage = count >= 8 ? 100 : 11 * count;
    return percentage;
  };

  /**
   * To handle validation on clicking save
   * @param {*} type
   */
  async function handleSave(type) {
    let error = [];
    setDisableButton(true);
    if (type == "draft") {
      if (!wantAdData?.adType) {
        setTypeSelectionError(true);
        error.push("adType");
      }
    } else {
      if (!wantAdData?.adType) {
        setTypeSelectionError(true);
        error.push("adTypeRef", "adType");
      }

      if (
        (!wantAdData?.location || !wantAdData?.county) &&
        (!wantAdData?.zipCode || wantAdData?.zipCode.length == 0)
      ) {
        setLocationCityError(true);
        setZipCodeError(true);
        error.push("locationRef", "city");
      } else {
        if (
          wantAdData?.location ||
          wantAdData?.location != "" ||
          !wantAdData?.zipCode.length > 0
        ) {
          if (!wantAdData?.mapRadius && !wantAdData?.drawnPolygon) {
            setLocationRadiusError(true);
            error.push("locationRef", "mapRadius");
          }
        }
      }

      if (wantAdData?.adType == BUY && !wantAdData?.timeLine) {
        setTimeLineError(true);
        error.push("timeLineRef", "timeLine");
      }

      if (wantAdData?.adType == LONG_RENT && !wantAdData?.moveInTimeLine) {
        setTimeLineError(true);
        error.push("timeLineRef", "timeLine");
      }
      if (
        wantAdData?.adType == LONG_RENT &&
        wantAdData?.moveInTimeLine == EXACT_MOVE_DATE_TYPE &&
        !wantAdData?.startDate
      ) {
        setExactMoveDateError(true);
        error.push("timeLineRef", "startDate");
      }
      if (
        wantAdData?.adType == LONG_RENT &&
        wantAdData?.moveInTimeLine == EXACT_MOVE_DATE_TYPE &&
        wantAdData?.startDate
      ) {
        const isDateValid = isValidDate({
          dateString: wantAdData?.startDate,
          format: DATE_FORMAT_MM_DD_YYYY,
        });
        if (!isDateValid) {
          setExactMoveDateError(true);
          error.push("timeLineRef", "startDate");
        }
      }
      if (wantAdData?.adType == SHORT_RENT && !wantAdData?.dateType) {
        setTimeCalenderError(true);
        error.push("timeLineRef", "dateType");
      }
      if (
        wantAdData?.adType == SHORT_RENT &&
        wantAdData?.dateType == 1 &&
        (!wantAdData?.startDate || !wantAdData?.endDate)
      ) {
        setDateTextBoxError(true);
        error.push("timeLineRef", "dateType");
      }

      if (
        wantAdData?.adType == SHORT_RENT &&
        wantAdData?.dateType == 2 &&
        (!wantAdData?.duration || !wantAdData?.month)
      ) {
        setDateTextBoxError(true);
        error.push("timeLineRef", "dateType");
      }
      if (!wantAdData?.prprtyType) {
        setPropertyTypeError(true);
        error.push("propertyTypeRef", "prprtyType");
      } else {
        if (
          (wantAdData?.prprtyType != IS_LAND && !wantAdData?.prptySubTypes) ||
          wantAdData?.prptySubTypes?.length == 0
        ) {
          if (wantAdData?.adType == BUY) {
            setPropertyTypeError(true);
            error.push("propertyTypeRef", "prprtyType");
          } else {
            setSubPropertyTypeError(true);
            error.push("propertyTypeRef", "prptySubTypes");
          }
        }
      }

      if (
        wantAdData?.prprtyType != IS_PRIVATE_ROOM &&
        wantAdData?.prprtyType != IS_LAND
      ) {
        if (!wantAdData?.noBedRm) {
          setRequirementBedroomsError(true);
          error.push("mustHaveRef", "noBedRm");
        }

        if (!wantAdData?.noBathRm) {
          setRequirementBathroomsError(true);
          error.push("mustHaveRef", "noBathRm");
        }
        if (!wantAdData?.noBedRm || !wantAdData?.noBathRm) {
          setRequirementTextColor(true);
        }
      }
    }

    if (wantAdData?.sqFtMax && wantAdData?.sqFtMin) {
      if (
        convertToNumber(wantAdData?.sqFtMin) >=
        convertToNumber(wantAdData?.sqFtMax)
      ) {
        error.push("mustHaveRef", "sqftMaxLesser");
        setRequirementTextColor(true);
      }
    }

    if (wantAdData?.minLtSz && wantAdData?.maxLtSz) {
      if (
        convertToNumber(wantAdData?.minLtSz) >=
        convertToNumber(wantAdData?.maxLtSz)
      ) {
        error.push("mustHaveRef", "lotSizeMaxLesser");
        setRequirementTextColor(true);
      }
    }

    if (wantAdData?.yearBuiltOption == 1) {
      if (wantAdData.yrBltMin && wantAdData.yrBltMax) {
        if (
          convertToNumber(wantAdData.yrBltMax) < YEAR_BUILT_MIN ||
          convertToNumber(wantAdData.yrBltMax) > YEAR_BUILT_MAX ||
          convertToNumber(wantAdData.yrBltMin) < YEAR_BUILT_MIN ||
          convertToNumber(wantAdData.yrBltMin) > YEAR_BUILT_MAX
        ) {
          (convertToNumber(wantAdData.yrBltMax) < YEAR_BUILT_MIN ||
            convertToNumber(wantAdData.yrBltMax) > YEAR_BUILT_MAX) &&
            error.push("yearBuiltMaxRange");
          (convertToNumber(wantAdData.yrBltMin) < YEAR_BUILT_MIN ||
            convertToNumber(wantAdData.yrBltMin) > YEAR_BUILT_MAX) &&
            error.push("yearBuiltMinRange");
        } else if (
          convertToNumber(wantAdData.yrBltMax) <
          convertToNumber(wantAdData.yrBltMin)
        ) {
          error.push("mustHaveRef", "yearBuiltError");
        }
      } else if (!wantAdData.yrBltMin || !wantAdData.yrBltMax) {
        !wantAdData.yrBltMin && error.push("mustHaveRef", "yearBuiltMinDate");
        !wantAdData.yrBltMax && error.push("mustHaveRef", "yearBuiltMaxDate");
      }
    }

    if (wantAdData?.minBdgt && wantAdData?.maxBdgt) {
      if (
        convertToNumber(wantAdData?.minBdgt) >=
        convertToNumber(wantAdData?.maxBdgt)
      ) {
        error.push("BudgetRef", "maxBdgt");
        setBudgetError(true);
      }
    }

    if (type == "save") {
      if (!wantAdData?.adTitle) {
        setTitleError(true);
        error.push("DescriptionRef", "adTitleTextBox");
      }

      if (wantAdData?.adType == BUY && !wantAdData?.buyersAgreementSigned) {
        setBuyerAgreementError(true);
        error.push("BuyerSectionRef", "buyerAgreementSigned");
      }
    }
    if (wantAdData?.adTitle && !textValidations(wantAdData?.adTitle)) {
      error.push("DescriptionRef", "adTitle");
      setTitleError(true);
    }

    if (wantAdData?.adDesc && !textValidations(wantAdData?.adDesc)) {
      error.push("DescriptionRef", "adDesc");
      setDescriptionError(true);
    }

    if (
      (wantAdData?.isPreApprLoan == 1 || wantAdData?.isPreApprLoan == "Yes") &&
      !wantAdData?.agreePreApprovedLoan
    ) {
      error.push("DescriptionRef", "agreePreApprovedLoan");
    }

    if (
      type == "save" &&
      wantAdData?.adType == BUY &&
      !isBuyerAgreementChecked
    ) {
      setBuyerAgreementError(true);
      error.push("BuyerSectionRef", "buyersAgreementSigned");
    }

    if (error.length == 0) {
      if (thumbnailImgUrlError) {
        window.scrollTo(0, thumbnailImgUrlRef.current.offsetTop);
        setDisableButton(false);
      } else {
        if (wantAdData?.videoUrl == "") {
          handleFormValues({ thumbnailImgUrl: "" });
        }

        handleFormValues({ validationErrors: [], updatedAt: Date.now() });

        if (type === "draft") {
          startLoading(LOADING_KEY);
          handleCaptureMapImage(type);
        } else {
          handleFormValues({
            videoUrl: videoUrl ?? wantAdData?.videoUrl,
            thumbnailImgUrl:
              wantAdData?.videoUrl == ""
                ? null
                : videoThumbnailUrl || wantAdData?.thumbnailImgUrl,
            cmpldPerctg: 100,
            actvStep: 10,
            isAgentCreated: true,
          });

          if (
            !wantAdData?.isGitchaAvailable &&
            wantAdData?.zipCode?.length === 0
          ) {
            const response = await checkGitchAvailability({
              state: _.get(wantAdData, "state", ""),
              county: _.get(wantAdData, "county", ""),
            });

            const isGitchaAvailable = _.get(response, "result", "");
            handleFormValues({ isGitchaAvailable });

            if (!isGitchaAvailable) {
              setGitchaModal(true);
              setDisableButton(false);
            } else {
              setTimeout(() => {
                saveMemberWantAdData(wantAdData?.mapImg, false, false, false, true);
              }, 10);
            }
          } else {
            setTimeout(() => {
              saveMemberWantAdData(wantAdData?.mapImg, false, false, false, true);
            }, 10);
          }
        }
      }
    } else {
      // Must mirror the DOM order of the sections, so the page jumps to the
      // FIRST error a user would scroll past — mirrors the visual order.
      const scrollOrder = [
        "ClientRef",
        "adTypeRef",
        "locationRef",
        "propertyTypeRef",
        "mustHaveRef",
        "BudgetRef",
        "timeLineRef",
        "DescriptionRef",
        "BuyerSectionRef",
      ];

      const scrollTargets = {
        ClientRef: ClientRef,
        adTypeRef: adTypeRef,
        locationRef: locationRef,
        timeLineRef: timeLineRef,
        propertyTypeRef: propertyTypeRef,
        mustHaveRef: mustHaveRef,
        BudgetRef: BudgetRef,
        DescriptionRef: DescriptionRef,
        BuyerSectionRef: BuyerSectionRef,
      };

      for (let i = 0; i < scrollOrder.length; i++) {
        if (
          error.includes(scrollOrder[i]) &&
          scrollTargets[scrollOrder[i]] &&
          scrollTargets[scrollOrder[i]].current
        ) {
          window.scrollTo(
            0,
            scrollTargets[scrollOrder[i]].current.offsetTop - SCROLL_OFFSET,
          );
          break;
        }
      }

      setDisableButton(false);
      handleFormValues({ validationErrors: error, updatedAt: Date.now() });
    }
  }

  /**
   * To capture map image
   * @param {*} type
   * @param {*} onkeyupSave
   */
  const handleCaptureMapImage = (type, onkeyupSave = false) => {
    const canvas = mapRef.current?.canvas?.();
    if (!canvas) return;

    canvas.toBlob(
      (blob) => {
        if (!blob) return;
        handleMapImageUpload(blob, type, onkeyupSave);
      },
      "image/jpeg",
      1,
    );
  };

  const queryClient = useQueryClient();

  const presignedUrlMutation = useMutation({
    mutationFn: (folder) => createPreSignedUrl(true, folder),
  });

  const presignedVideoUrlMutation = useMutation({
    mutationFn: (folder) => createPreSignedUrlForVideo(true, folder),
  });

  const saveWantAdMutation = useMutation({
    mutationFn: ({ payload }) => saveMemberWantAd(payload),
    onSuccess: (response, { onkeyupSave, isVideo, isPostAd }) => {
      const responseResult = _.get(response, "result", null);
      if (response.errorCode === 0 && responseResult) {
        // The details page caches for 5 minutes (global staleTime); landing
        // on it right after a save must show the saved values, not the cache.
        queryClient.invalidateQueries({ queryKey: ["wantAdDetails"] });
        queryClient.invalidateQueries({ queryKey: ["wantAdMlsMatches"] });
        queryClient.invalidateQueries({ queryKey: ["aiRanking"] });
        queryClient.invalidateQueries({ queryKey: ["agentWantAds"] });
        if (
          wantAdData.purchaseType ||
          wantAdData.creditScore ||
          wantAdData.prchTypeId ||
          wantAdData.pFinance
        ) {
          saveStrengthenData(responseResult.wantAdId, onkeyupSave, isPostAd);
        } else {
          if (isPostAd) {
            stopLoading(LOADING_KEY);
            localStorage.removeItem(AGENT_WANTAD_KEY);
            const slug = _.get(responseResult, "slug");
            navigate(`${pageURLs.wantAdDetails}/${slug}`, {
              state: { isFromConfirmationPage: true },
              replace: true,
            });
          } else if (!onkeyupSave && !isVideo) {
            stopLoading(LOADING_KEY);
            localStorage.removeItem(AGENT_WANTAD_KEY);
            navigate(pageURLs.agentMyWantAdListings);
          } else {
            stopLoading(LOADING_KEY);
            handleFormValues({ wantAdId: responseResult.wantAdId });
          }
        }
      } else {
        console.log("Something went wrong");
        stopLoading(LOADING_KEY);
      }
    },
    onError: (err) => {
      console.log("Error", err);
      stopLoading(LOADING_KEY);
    },
  });

  const saveStrengthenMutation = useMutation({
    mutationFn: ({ payload }) => saveMemberWantAdstrengthenData(payload),
    onSuccess: (response, { wantAdId, onkeyupSave, isPostAd }) => {
      stopLoading(LOADING_KEY);
      const responseResult = _.get(response, "result", null);
      if (response.errorCode === 0 && responseResult) {
        if (isPostAd) {
          localStorage.removeItem(AGENT_WANTAD_KEY);
          const slug = _.get(responseResult, "slug");
          navigate(`${pageURLs.wantAdDetails}/${slug}`, {
            state: { isFromConfirmationPage: true },
            replace: true,
          });
        } else if (!onkeyupSave) {
          localStorage.removeItem(AGENT_WANTAD_KEY);
          navigate(pageURLs.agentMyWantAdListings);
        } else {
          handleFormValues({ wantAdId: wantAdId });
        }
      }
    },
    onError: (err) => {
      console.log("Error", err);
      stopLoading(LOADING_KEY);
    },
  });

  /**
   * To handle map image upload
   * @param {*} image
   * @param {*} type
   * @param {*} onkeyupSave
   */

  const handleMapImageUpload = async (
    image, // The uploaded image file
    type, // "draft" or "final"
    onkeyupSave, // Boolean flag
    isVideo = false, // Optional, defaults to false
    isThumbnail = false, // Optional, defaults to false
  ) => {
    try {
      if (!image) {
        alert("Something went wrong while fetching map image.");
        return;
      }

      const preSignedUrlRes = await presignedUrlMutation.mutateAsync(
        _.get(wantAdData, "s3ImageFolder", ""),
      );
      if (preSignedUrlRes && _.get(preSignedUrlRes, "errorCode") === 0) {
        const preSignedUrlsArray = _.get(preSignedUrlRes, "result", []);
        const preSignedS3Url = preSignedUrlsArray
          ? _.get(preSignedUrlsArray[0], "presignedUrl", "")
          : "";

        const s3FullUrl = await uploadMapImageToS3(preSignedS3Url, image);
        //TODO: Temporary fix for upload
        if (s3FullUrl || s3FullUrl == "") {
          const imageUrl = s3FullUrl.split("?")[0];
          if (isThumbnail) {
            setVideoThumbnailUrl(imageUrl);
          }
          if (isVideo) {
            const videoPresignedUrl =
              await presignedVideoUrlMutation.mutateAsync(
                _.get(wantAdData, "s3ImageFolder", ""),
              );
            const s3FullVideoUrl = await uploadVideoToS3(
              videoPresignedUrl,
              image,
              (progress) => {
                setVideoUploadProgress(progress);
              },
            );
            const videoUrl = s3FullVideoUrl.split("?")[0];

            setVideoUrl(videoUrl);
          }

          if (type === "draft") {
            saveMemberWantAdData(imageUrl, onkeyupSave, isVideo, isThumbnail);
          } else {
            handleFormValues({
              mapImg: imageUrl,
              videoUrl: videoUrl ?? wantAdData?.videoUrl,
              thumbnailImgUrl:
                videoUrl == ""
                  ? null
                  : videoThumbnailUrl || wantAdData?.thumbnailImgUrl, // Set thumbnail here
              cmpldPerctg: 100,
              actvStep: 10,
              isAgentCreated: true,
            });

            if (
              !wantAdData?.isGitchaAvailable &&
              wantAdData?.zipCode?.length === 0
            ) {
              const response = await checkGitchAvailability({
                state: _.get(wantAdData, "state", ""),
                county: _.get(wantAdData, "county", ""),
              });

              const isGitchaAvailable = _.get(response, "result", "");
              handleFormValues({ isGitchaAvailable });

              if (!isGitchaAvailable) {
                setGitchaModal(true);
                setDisableButton(false);
              } else {
                setTimeout(() => {
                  saveMemberWantAdData(imageUrl, false, false, false, true);
                }, 10);
              }
            } else {
              setTimeout(() => {
                saveMemberWantAdData(imageUrl, false, false, false, true);
              }, 10);
            }
          }
        } else {
          setDisableButton(false);
        }
      } else {
        setDisableButton(false);
      }
    } catch (error) {
      console.error("Error during map image upload:", error);
      setDisableButton(false);
    }
  };

  /**
   * To check if gitcha available in location
   * @param {*} param0
   * @returns
   */
  const checkGitchAvailability = async ({ zip, state, city, county }) => {
    // Availability is a property of the state/county pair, so an on-demand
    // fetchQuery lets the draft and publish paths share one cached answer.
    return queryClient.fetchQuery({
      queryKey: ["gitchaAvailability", state ?? null, county ?? null],
      queryFn: () => checkGitchaAvailable({ county: county, state: state }),
    });
  };
  /**
   * To save want ad data
   * @param {*} imageUrl
   * @param {*} onkeyupSave
   */
  const saveMemberWantAdData = async (
    imageUrl,
    onkeyupSave = false,
    isVideo = false,
    isThumbnail = false,
    isPostAd = false,
  ) => {

    let userId = getUserId();

    let requestPayLoad = wantAdData;
    if (!requestPayLoad) {
      requestPayLoad = getLocalStorage(AGENT_WANTAD_KEY);
    }
    let arrayValue = [];
    if (requestPayLoad?.zipIdValues) {
      requestPayLoad?.zipIdValues.map((zip) => {
        arrayValue.push(zip?.zipId);
      });
      requestPayLoad.zipId = arrayValue;
    } else if (requestPayLoad?.zipCode) {
      requestPayLoad?.zipCode.map((zip) => {
        if (zip?.zipId && zip?.zipId != null) {
          arrayValue.push(zip?.zipId);
        }
      });
      requestPayLoad.zipId = arrayValue;
    }
    requestPayLoad.isZipcodeBased =
      requestPayLoad.zipId?.length > 0 ? true : false;

    requestPayLoad.drawnPolygon = wantAdData?.drawnPolygon || null;

    isVideo
      ? (requestPayLoad.videoUrl = videoUrl)
      : (requestPayLoad.mapImg = imageUrl);
    requestPayLoad.cmpldStep = _.get(wantAdData, "actvStep", 1);
    requestPayLoad.IsSavedDraft = isPostAd ? false : true;
    requestPayLoad.IsPublished = isPostAd ? true : false;
    if (isPostAd) {
      delete requestPayLoad.tlText;
      delete requestPayLoad.prptyTypeTxt;
      delete requestPayLoad.wantAdValErrors;
    }

    requestPayLoad.isAgentCreated = true;

    // The confirmation page used to stamp the current MLS onto the payload
    // before posting. Now that we publish straight from the form, set it here
    // so the want-ad is associated with the correct MLS on creation.
    requestPayLoad.mls = mls;

    // Ensure a default radius is always supplied so that maps render correctly
    if (
      !requestPayLoad.drawnPolygon &&
      (!requestPayLoad.mapRadius ||
        requestPayLoad.mapRadius === "" ||
        requestPayLoad.mapRadius === null)
    ) {
      requestPayLoad.mapRadius = 5;
      if (!requestPayLoad.mapZoom && requestPayLoad.mapZoom !== 0) {
        requestPayLoad.mapZoom = 10;
      }
    }
    if (isAgent && !isPremiumUser && !requestPayLoad.clientId) {
      requestPayLoad.isAgentAsSeller = true;
    } else if (requestPayLoad.clientId) {
      requestPayLoad.isAgentAsSeller = false;
    }
    if (isGitchaDefaultWebsite) {
      requestPayLoad.syndicateToThePublic = true;
    }
    requestPayLoad.cmpldPerctg = calculatePercentageofCompletion();

    requestPayLoad.videoUrl = videoUrl ?? wantAdData?.videoUrl;
    requestPayLoad.thumbnailImgUrl =
      imageUrl || wantAdData?.thumbnailImgUrl || null;
    requestPayLoad.buyersAgreementSigned = wantAdData?.buyersAgreementSigned ?? false;
    //patch
    if (wantAdData?.videoUrl == "") {
      requestPayLoad.thumbnailImgUrl = null;
    }
    saveWantAdMutation.mutate({
      payload: requestPayLoad,
      onkeyupSave,
      isVideo,
      isPostAd,
    });
  };
  /**
   * To save strengthen want ad data
   * @param {*} wantAdIdValue
   * @param {*} onkeyupSave
   */
  const saveStrengthenData = async (
    wantAdIdValue,
    onkeyupSave,
    isPostAd = false,
  ) => {
    const wantAd = getLocalStorage(AGENT_WANTAD_KEY);
    const wantAdId = wantAdIdValue;
    let requestPayLoad = {};
    let isApproveLoan = "";
    if (
      _.get(wantAdData, "isPreApprLoan", null) === "Yes" ||
      _.get(wantAdData, "isPreApprLoan", null) == true
    ) {
      isApproveLoan = true;
    } else if (
      _.get(wantAdData, "isPreApprLoan", null) === "No" ||
      _.get(wantAdData, "isPreApprLoan", null) == true
    ) {
      isApproveLoan = false;
    }
    requestPayLoad.isPreApprLoan = isApproveLoan;
    const is1031Exchange =
      wantAd?.is1031Exchange == "Yes" || wantAd?.is1031Exchange == 1
        ? true
        : false;
    requestPayLoad.wantAdId = wantAdId;
    requestPayLoad.isPreApprLoan = isApproveLoan;
    requestPayLoad.is1031Exchange = is1031Exchange;
    requestPayLoad.completedStep = 1;
    requestPayLoad.adType =
      wantAdData.adType == BUY ? "BUY_STRENGTHEN" : "LTR_STRENGTHEN";
    requestPayLoad.creditScore = wantAdData.creditScore;
    requestPayLoad.maxBdgt = wantAdData.maxBdgt;
    requestPayLoad.minBdgt = wantAdData.minBdgt;
    requestPayLoad.pFinance = wantAdData.pFinance || wantAdData.finTypeId;
    requestPayLoad.purchaseType =
      wantAdData.purchaseType || wantAdData.prchTypeId;

    saveStrengthenMutation.mutate({
      payload: requestPayLoad,
      wantAdId,
      onkeyupSave,
      isPostAd,
    });
  };

  return (
    <>
      <RequestStayAvailability
        show={showRequestStayPopuop}
        locationFromSTorage={browserLocation}
        onHide={handleStayRequestPopupClose}
      />

      <PageWrapper ref={ClientRef}>
        <div className="row m-0" ref={formRef}>
          {showWantadPublished === true ? (
            <h2 className="text-center">Want-Listing already published</h2>
          ) : (
            <div className="col-md-12">
              <div className="edit-want-ad-wrapper mw-626 wa-rhythm">
                {wantAdData?.isFilledByClient && !wantAdData?.isPublished ? (
                  <>
                    <h2 className="pt-3">Review, Title, and Post!</h2>
                    <h6 className="mb-40">
                      Make sure everything looks good, especially the
                      description. Once you title it, you're ready to post!
                    </h6>
                  </>
                ) : (
                  <>
                    {isEdit && <BackButton className="mt-3" />}
                    <h2 className="pt-3 agent-create-head">
                      {wantAdData?.isEdit
                        ? "Edit Want-Listing"
                        : "Create Want-Listing"}
                    </h2>
                    <p className="mb-40 agent-create-para">
                      Help your clients find exactly what they're looking for.
                    </p>
                  </>
                )}

                {wantAdData?.adType && (
                  <WantAdOptimizationScore wantAdData={wantAdData} />
                )}

                {wantAdData?.adType && (
                  <div
                    className={
                      locationRadiusError
                        ? "wantad-location-wrap select-type-wrap red-marked-wrap"
                        : "agent-create-label"
                    }
                    ref={locationRef}
                    id="opt-anchor-location"
                  >
                    <h6
                      className={
                        locationCityError || locationRadiusError
                          ? "red-marked-heading"
                          : "agent-location-head"
                      }
                    >
                      Location{" "}
                    </h6>
                    <WantAdLocation
                      handleFormValues={handleFormValues}
                      ref={mapRef}
                      location={_.get(wantAdData, "location", null)}
                      s3Imagefolder={_.get(wantAdData, "s3ImageFolder", false)}
                      lat={_.get(wantAdData, "lat", null)}
                      lng={_.get(wantAdData, "lng", null)}
                      mapZoom={_.get(wantAdData, "mapZoom", null)}
                      mapRadius={_.get(wantAdData, "mapRadius", null)}
                      neighborHood={_.get(wantAdData, "neighborHood", null)}
                      highSchool={_.get(wantAdData, "highSchool", null)}
                      zip={_.get(wantAdData, "zip", null)}
                      adType={_.get(wantAdData, "adType", null)}
                      city={_.get(wantAdData, "city", null)}
                      state={_.get(wantAdData, "state", null)}
                      county={_.get(wantAdData, "county", null)}
                      session={AGENT_WANTAD_KEY}
                      targetRef={targetRef}
                      isGitchaAvailable={_.get(
                        wantAdData,
                        "isGitchaAvailable",
                        null,
                      )}
                      locationCityError={locationCityError}
                      locationRadiusError={locationRadiusError}
                      zipCode={_.get(wantAdData, "zipCode", [])}
                      zipIdValues={_.get(wantAdData, "zipIdValues", null)}
                      zipCodeError={zipCodeError}
                      setLocationCityError={setLocationCityError}
                      setLocationError={setLocationError}
                      locationError={locationError}
                      isFromConfirmationPage={isFromConfirmationPage}
                      fireDisplaced={_.get(wantAdData, "fireDisplaced", null)}
                    />
                  </div>
                )}

                {wantAdData?.adType && (
                  <div
                    className={
                      propertyTypeError || subPropertyTypeError
                        ? "wantad-type-wrap select-type-wrap red-marked-wrap"
                        : "wantad-type-wrap select-type-wrap agent-create-label"
                    }
                    ref={propertyTypeRef}
                    id="opt-anchor-basics"
                  >
                    {wantAdData?.adType == LONG_RENT ||
                      wantAdData?.adType == SHORT_RENT ? (
                      <>
                        <h6 className={propertyTypeError && "red-marked-heading"}>
                          Property type <span>*</span>
                        </h6>
                        <WantAdRentPropertyTypes
                          handleFormValues={handleFormValues}
                          propertyType={_.get(wantAdData, "prprtyType", null)}
                          adType={_.get(wantAdData, "adType", null)}
                          clearPreviousStates={clearPreviousStates}
                          prptySubTypes={_.get(wantAdData, "prptySubTypes", [])}
                          propertyTypeError={propertyTypeError}
                          subPropertyTypeError={subPropertyTypeError}
                        />
                      </>
                    ) : (
                      <WantAdType
                        handleFormValues={handleFormValues}
                        propertyCategory={_.get(wantAdData, "propertyCategory", null)}
                        clearPreviousStates={clearPreviousStates}
                        propertyTypeError={propertyTypeError}
                        prptySubTypes={_.get(wantAdData, "prptySubTypes", [])}
                      />
                    )}

                  </div>
                )}

                {wantAdData?.adType && wantAdData?.prprtyType && (
                  <div
                    className={
                      requirementTextColor
                        ? "requirements-wrap red-marked-wrap mb-3"
                        : "requirements-wrap mb-3 agent-create-label"
                    }
                    ref={mustHaveRef}
                    id="opt-anchor-details"
                  >
                    <h6>Requirements</h6>
                    {wantAdData?.adType == SHORT_RENT &&
                      wantAdData?.prprtyType != IS_LAND &&
                      wantAdData?.prprtyType != IS_PRIVATE_ROOM && (
                        <WantAdShortRentMstHves
                          handleFormValues={handleFormValues}
                          noOfBedrooms={_.get(wantAdData, "noBedRm", null)}
                          noOfBathrooms={_.get(wantAdData, "noBathRm", null)}
                          noOfBeds={_.get(wantAdData, "noOfBeds", null)}
                          alwPets={_.get(wantAdData, "alwPets", "")}
                          adaAccess={_.get(wantAdData, "adaAccess", "")}
                          requirementBedroomsError={requirementBedroomsError}
                          requirementBathroomsError={requirementBathroomsError}
                        />
                      )}
                    {wantAdData?.adType == LONG_RENT &&
                      wantAdData?.prprtyType != IS_LAND &&
                      wantAdData?.prprtyType != IS_PRIVATE_ROOM && (
                        <WantAdRentMustHaves
                          handleFormValues={handleFormValues}
                          noOfBedrooms={_.get(wantAdData, "noBedRm", null)}
                          noOfBathrooms={_.get(wantAdData, "noBathRm", null)}
                          SFMin={_.get(wantAdData, "sqFtMin", null)}
                          SFMax={_.get(wantAdData, "sqFtMax", null)}
                          garageSpace={_.get(wantAdData, "grgSpce", null)}
                          entreSpceMstHve={_.get(
                            wantAdData,
                            "entreSpceMstHve",
                            [],
                          )}
                          alwLrgDogs={_.get(wantAdData, "alwLrgDogs", "")}
                          alwSmlDogs={_.get(wantAdData, "alwSmlDogs", "")}
                          alwCats={_.get(wantAdData, "alwCats", "")}
                          adaAccess={_.get(wantAdData, "adaAccess", "")}
                          stories={_.get(wantAdData, "stories", null)}
                          mustHaveErrors={_.get(
                            wantAdData,
                            "validationErrors",
                            null,
                          )}
                          requirementBedroomsError={requirementBedroomsError}
                          requirementBathroomsError={requirementBathroomsError}
                        />
                      )}

                    {((wantAdData?.prprtyType != IS_LAND &&
                      wantAdData?.adType == BUY) ||
                      (convertToNumber(wantAdData?.prprtyType) !=
                        IS_PRIVATE_ROOM &&
                        convertToNumber(wantAdData?.prprtyType) != IS_LAND &&
                        wantAdData?.adType != LONG_RENT &&
                        wantAdData?.adType != SHORT_RENT)) && (
                        <WantAdMustHaves
                          handleFormValues={handleFormValues}
                          noOfBedrooms={_.get(wantAdData, "noBedRm", null)}
                          noOfBathrooms={_.get(wantAdData, "noBathRm", null)}
                          noOfHalfBathrooms={_.get(wantAdData, "noHalfBathRm", null)}
                          SFMin={_.get(wantAdData, "sqFtMin", null)}
                          SFMax={_.get(wantAdData, "sqFtMax", null)}
                          garageSpace={_.get(wantAdData, "grgSpce", null)}
                          yearBuiltMin={_.get(wantAdData, "yrBltMin", null)}
                          yearBuildMax={_.get(wantAdData, "yrBltMax", null)}
                          mustHaveErrors={_.get(
                            wantAdData,
                            "validationErrors",
                            null,
                          )}
                          stories={_.get(wantAdData, "stories", null)}
                          yearBuiltOption={_.get(
                            wantAdData,
                            "yearBuiltOption",
                            null,
                          )}
                          minLtSz={_.get(wantAdData, "minLtSz", null)}
                          maxLtSz={_.get(wantAdData, "maxLtSz", null)}
                          adaAccess={_.get(wantAdData, "adaAccess", null)}
                          requirementBedroomsError={requirementBedroomsError}
                          requirementBathroomsError={requirementBathroomsError}
                          propertyType={wantAdData?.prprtyType}
                        />
                      )}
                    {convertToNumber(wantAdData?.prprtyType) ===
                      IS_PRIVATE_ROOM && (
                        <WantAdRentMustHavePrivate
                          handleFormValues={handleFormValues}
                          accsPvtBthRm={_.get(wantAdData, "accsPvtBthRm", "")}
                          alwPets={_.get(wantAdData, "alwPets", "")}
                          adaAccess={_.get(wantAdData, "adaAccess", "")}
                          pvtEntrnce={_.get(wantAdData, "pvtEntrnce", "")}
                        />
                      )}
                    {convertToNumber(wantAdData?.prprtyType) == IS_LAND && (
                      <WantAdLandMustHaves
                        handleFormValues={handleFormValues}
                        lotType={_.get(wantAdData, "lotType", null)}
                        roadType={_.get(wantAdData, "roadType", null)}
                        isPrivtDrilInstld={_.get(
                          wantAdData,
                          "isPrvtDrInst",
                          null,
                        )}
                        onSiteElec={_.get(wantAdData, "onSiteElec", null)}
                        waterSupply={_.get(wantAdData, "waterSupply", null)}
                        isDrldWelInstld={_.get(
                          wantAdData,
                          "isDrldWelInst",
                          null,
                        )}
                        wasteWtrSys={_.get(wantAdData, "wasteWtrSys", null)}
                        isSepTankInstld={_.get(
                          wantAdData,
                          "isSepTankInst",
                          null,
                        )}
                        isSepTankApprvd={_.get(
                          wantAdData,
                          "isSepTankAppr",
                          null,
                        )}
                        minLtSz={_.get(wantAdData, "minLtSz", null)}
                        maxLtSz={_.get(wantAdData, "maxLtSz", null)}
                        mustHaveErrors={_.get(
                          wantAdData,
                          "validationErrors",
                          null,
                        )}
                        propertyType={wantAdData?.prprtyType}
                      />
                    )}
                  </div>
                )}

                <div id="opt-anchor-niceToHaves" />
                {wantAdData?.adType && wantAdData?.prprtyType && (
                  <NiceToHave
                    selectedNiceToHave={wantAdData?.nice2Have}
                    selectedniceToHavesList={selectedniceToHavesList}
                    propertyType={wantAdData?.prprtyType}
                    adType={wantAdData?.adType}
                    handleFormValues={handleFormValues}
                    title="Nice-to-haves"
                    aiPowered
                  />
                )}
                <div id="opt-anchor-niceToHaves-end" />

                {wantAdData?.adType && wantAdData?.prprtyType && (
                  <div
                    className={
                      budgetError
                        ? "finance-wrap red-marked-wrap pb-24"
                        : "finance-wrap pb-24 agent-create-label"
                    }
                    ref={BudgetRef}
                    id="opt-anchor-budget"
                  >
                    <h6>Finance</h6>
                    <WantAdBudget
                      handleFormValues={handleFormValues}
                      budgetMin={_.get(wantAdData, "minBdgt", null)}
                      budgetMax={_.get(wantAdData, "maxBdgt", null)}
                      isAdjustBdget={_.get(wantAdData, "isAdjustBdget", null)}
                      isPreApprLoan={_.get(wantAdData, "isPreApprLoan", null)}
                      adType={wantAdData?.adType}
                      errors={_.get(wantAdData, "validationErrors", null)}
                    />

                    <div className="wantad-type-wrap select-type-wrap pb-2">
                      {wantAdData?.adType == BUY && (
                        <>
                          <label className="form-label mb-12 wanted-info-label">
                            Purchase Type
                          </label>
                          <WantAdPropertyPurchase
                            handleFormValues={handleFormValues}
                            propertyPurchase={
                              _.get(wantAdData, "purchaseType", null) ||
                              _.get(wantAdData, "prchTypeId", null)
                            }
                            is1031Exchange={_.get(
                              wantAdData,
                              "is1031Exchange",
                              null,
                            )}
                            isEdit="true"
                          />
                        </>
                      )}
                      {wantAdData?.adType == LONG_RENT && (
                        <>
                          <label className="form-label">
                            Credit score range
                          </label>
                          <WantAdRentCreditScore
                            handleFormValues={handleFormValues}
                            creditScore={_.get(wantAdData, "creditScore", null)}
                          />
                        </>
                      )}
                      {wantAdData?.adType == BUY && (
                        <>
                          <label className="form-label wanted-info-label">
                            Financing
                          </label>
                          <WantAdPurchaseFinance
                            handleFormValues={handleFormValues}
                            timeLine={_.get(wantAdData, "timeLine", null)}
                            financeType={
                              _.get(wantAdData, "finTypeId", null) ||
                              _.get(wantAdData, "pFinance", null)
                            }
                            isPreApprLoan={_.get(
                              wantAdData,
                              "isPreApprLoan",
                              null,
                            )}
                            agreePreApprovedLoan={
                              _.get(wantAdData, "agreePreApprovedLoan", null) ??
                              _.get(wantAdData, "isPreApprLoan", null)
                            }
                            errors={_.get(wantAdData, "validationErrors", null)}
                          />
                        </>
                      )}
                    </div>
                  </div>
                )}

                {wantAdData?.adType && (
                  <div
                    className="wantad-type-wrap select-type-wrap red-marked-wrap agent-create-label"
                    ref={timeLineRef}
                    id="opt-anchor-buyer"
                  >
                    <h6
                      className={
                        (timeLineError || timelineCalenderError) &&
                        "red-marked-heading"
                      }
                    >
                      Timeline <span>*</span>
                    </h6>
                    {wantAdData?.adType == LONG_RENT ||
                      wantAdData?.adType == SHORT_RENT ? (
                      <WantAdCalendar
                        handleFormValues={handleFormValues}
                        sDate={_.get(wantAdData, "startDate", null)}
                        eDate={_.get(wantAdData, "endDate", null)}
                        adType={_.get(wantAdData, "adType", null)}
                        dateType={_.get(wantAdData, "dateType", null)}
                        duration={_.get(wantAdData, "duration", null)}
                        month={_.get(wantAdData, "month", null)}
                        moveInTimeLine={convertToNumber(
                          _.get(wantAdData, "moveInTimeLine", null),
                        )}
                        moveInDate={_.get(wantAdData, "startDate", null)}
                        clearPreviousStates={clearPreviousStates}
                        timeLineError={timeLineError}
                        timelineCalenderError={timelineCalenderError}
                        exactMoveDateError={exactMoveDateError}
                        dateTextBoxError={dateTextBoxError}
                      />
                    ) : (
                      <WantAdTiming
                        handleFormValues={handleFormValues}
                        timeLine={_.get(wantAdData, "timeLine", null)}
                        adType={_.get(wantAdData, "adType", null)}
                        timeLineError={timeLineError}
                      />
                    )}
                  </div>
                )}

                <ClientSelection
                  isMandatory={false}
                  clientId={wantAdData?.clientId}
                  isAgentAsSeller={wantAdData?.isAgentAsSeller}
                  sessionData={sessionData}
                  handleFormValues={handleFormValues}
                  isfromWantAdPage={true}
                  clientSelectionError={clientSelectionError}
                  handleSaveToDraft={handleSaveToDraft}
                  isFilledByClient={wantAdData?.isFilledByClient}
                />

                {wantAdData?.adType && wantAdData?.prprtyType && (
                  <div
                    className={
                      titleTextBoxError || descriptionError
                        ? "description-wrap red-marked-wrap"
                        : "description-wrap agent-create-label pb-3"
                    }
                    ref={DescriptionRef}
                    id="opt-anchor-polish"
                  >
                    <h6
                      className={
                        (titleTextBoxError || descriptionError) &&
                        "red-marked-heading"
                      }
                    >
                      Description
                    </h6>
                    <WantAdDescription
                      handleFormValues={handleFormValues}
                      wantAdData={wantAdData}
                      adTitle={_.get(wantAdData, "adTitle", "")}
                      adDescription={_.get(wantAdData, "adDesc", "")}
                      errors={_.get(wantAdData, "validationErrors", null)}
                      titleTextBoxError={titleTextBoxError}
                      descriptionError={descriptionError}
                      titleRef={TitleRef}
                    />
                    <ComplianceWarning severity={severity} violations={violations} />
                    {/* The autotag panel lives under the textarea it reads;
                        chips it ticks land in the Nice-to-haves section above. */}
                    <AiNiceToHaveSuggestions
                      adTitle={wantAdData?.adTitle}
                      adDesc={wantAdData?.adDesc}
                      adType={wantAdData?.adType}
                      propertyType={wantAdData?.prprtyType}
                      selectedNiceToHave={wantAdData?.nice2Have}
                      handleFormValues={handleFormValues}
                    />
                  </div>
                )}

                {wantAdData?.adType == BUY && wantAdData?.prprtyType && (
                  <div
                    className={
                      buyerAgreementError
                        ? "finance-wrap pb-24 page-break-after agent-create-label red-marked-wrap"
                        : "finance-wrap pb-24 page-break-after agent-create-label"
                    }
                    ref={BuyerSectionRef}
                  >
                    <h6
                      className={
                        buyerAgreementError && "red-marked-heading"
                      }
                    >
                      Buyer Agreement <span>*</span>
                    </h6>
                    <BuyerAgreement
                      isChecked={_.get(
                        wantAdData,
                        "buyersAgreementSigned",
                        false,
                      )}
                      hasError={buyerAgreementError}
                      handleFormValues={handleFormValues}
                    />
                  </div>
                )}

                {!isGitchaDefaultWebsite &&
                  wantAdData?.adType &&
                  wantAdData?.prprtyType && (
                    <WantListingSyndication
                      handleFormValues={handleFormValues}
                      wantAdData={wantAdData}
                      isDisabled={isPremiumUser ? false : true}
                    />
                  )}
              </div>

              <div className="edit-want-ad-btnwrap mt-4 mb-4">
                {_.get(wantAdData, "isPublished", "") == 0 && (
                  <Button
                    variant=""
                    className="btn-tertiary me-2"
                    disabled={disableButton}
                    onClick={() => handleSave("draft")}
                  >
                    Save As Draft
                  </Button>
                )}
                <Button
                  variant="primary"
                  className="btn"
                  disabled={
                    disableButton ||
                      (videoUploadProgress > 0 && videoUploadProgress < 100)
                      ? true
                      : false
                  }
                  onClick={() => handleSave("save")}
                >
                  Confirm
                </Button>
              </div>
            </div>
          )}
        </div>
      </PageWrapper>

      <GitchaNotAvailableModal
        show={gitchaModalShow}
        onHide={() => setGitchaModal(false)}
      />
    </>
  );
};

export default AgentWantAdForm;
